import { render } from "./CabinetDetail.vue?vue&type=template&id=301f74d2&scoped=true&ts=true"
import script from "./CabinetDetail.ts?vue&type=script&lang=ts"
export * from "./CabinetDetail.ts?vue&type=script&lang=ts"

import "./CabinetDetail.scss?vue&type=style&index=0&id=301f74d2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-301f74d2"]])

export default __exports__